import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import api from '../../api';
import { useAuth } from '../../AuthContext';
import ApprovalGateway from '../../components/ApprovalGateway';
import InventoryGrid from '../../components/InventoryGrid';
import IssyBanner from '../../components/IssyBanner';

function SuppliesDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ below_par: 0, pending_orders: 0 });

  useEffect(() => {
    Promise.all([
      api.get('/inventory?below_par=true&is_food=false'),
      api.get('/orders?status=draft'),
    ]).then(([inv, orders]) => {
      setStats({ below_par: inv.data.length, pending_orders: orders.data.length });
    }).catch(() => {});
  }, []);

  return (
    <>
      <div className="page-header">
        <span className="page-title">Supplies Dashboard</span>
        <span className="text-sm text-gray">{user?.name}</span>
      </div>
      <div className="page-body">
        <div className="stat-grid">
          <div className={`stat-card ${stats.below_par > 0 ? 'danger' : 'success'}`}>
            <div className="stat-label">Supplies Below Par</div>
            <div className="stat-value">{stats.below_par}</div>
          </div>
          <div className={`stat-card ${stats.pending_orders > 0 ? 'warning' : ''}`}>
            <div className="stat-label">Pending Approvals</div>
            <div className="stat-value">{stats.pending_orders}</div>
          </div>
        </div>

        {stats.below_par > 0 && (
          <div className="alert alert-warning mt-4">
            ⚠️ {stats.below_par} non-food supplies need reordering.
          </div>
        )}
      </div>
    </>
  );
}

export default function SuppliesView() {
  return (
    <Routes>
      <Route index element={<SuppliesDashboard />} />
      <Route path="orders" element={<><div className="page-header"><span className="page-title">Approve Order</span></div><div className="page-body"><ApprovalGateway /></div></>} />
      <Route path="inventory" element={<><div className="page-header"><span className="page-title">Supplies Inventory</span></div><div className="page-body"><IssyBanner /><InventoryGrid filterFood={false} /></div></>} />
    </Routes>
  );
}
